const schema_old = {
  type: 'object',
  required: ['label', 'name', 'volume'],
  properties: {
    label: {
      type: 'string',
      title: 'Label',
    },
    name: {
      type: 'string',
      title: 'Name',
    },
    volume: {
      type: 'object',
      title: 'Volume',
      required: ['value', 'unit'],
      properties: {
        value: {
          type: 'number',
          title: 'Volume',
        },
        unit: {
          type: 'string',
          title: 'Unit',
          default: 'µL',
          enum: ['fL', 'pL', 'nL', 'µL', 'mL', 'L', 'kL', 'ML', 'GL'],
        },
      },
    },
    mass: {
      type: 'object',
      title: 'Mass',
      required: ['value', 'unit'],
      properties: {
        value: {
          type: 'number',
          title: 'Mass',
        },
        unit: {
          type: 'string',
          title: 'Unit',
          default: 'mg',
          enum: ['pg', 'ng', 'µg', 'mg', 'g', 'kg', 't', 'kt'],
        },
      },
    }
  },
};

const schema = {
  "type": "object",
  "properties": {
    "type": {
      "enum": ["solid", "liquid", "solution"]
    },
    "label": {
      "type": "string"
    },
    "name": {
      "type": "string"
    }
  },
  "required": ["type", "name", "label"],
  "allOf": [
    {
      "if": {
        "properties": { "type": { "const": "solid" } },
        "required": ["type"]
      },
      "then": {
        "properties": {
          "mass": {
            "type": "object",
            "title": "Mass",
            "required": ["value", "unit"],
            "properties": {
              "value": {
                "type": ["number", "null"],
                "title": "Mass"
              },
              "unit": {
                "type": "string",
                "title": "Unit",
                "default": "mg",
                "enum": ["pg", "ng", "µg", "mg", "g", "kg", "t", "kt"]
              }
            }
          },
          "molarMass": {
            "type": "object",
            "title": "Molar Mass",
            "required": ["value", "unit"],
            "properties": {
              "value": {
                "type": "number",
                "title": "Molar Mass"
              },
              "unit": {
                "type": "string",
                "title": "Unit",
                "default": "g/mol",
                "enum": ["g/mol"]
              }
            }
          },
          "nbMoles": {
            "type": "object",
            "title": "Number of Moles",
            "required": ["value", "unit"],
            "properties": {
              "value": {
                "type": ["number", "null"],
                "title": "Number of Moles"
              },
              "unit": {
                "type": "string",
                "title": "Unit",
                "default": "mol",
                "enum": ["fmol", "pmol", "nmol", "µmol", "mmol", "mol"]
              }
            }
          },
          "subtype": {
            "enum": ["dna", "peptide"]
          },
          "subtypeData": {
            "type": "object"
          }
        },
        "required": [],
        "allOf": [
          {
            "if": {
              "properties": { "subtype": { "const": "dna" } },
              "required": ["subtype"]
            },
            "then": {
              "properties": {
                "subtypeData": {
                  "type": "object",
                  "properties": {
                    "sequence": { "type": "string" },
                    "is_single_stranded": { "type": "boolean" }
                  },
                  "required": ["sequence", "is_single_stranded"]
                }
              },
              "required": ["subtypeData"]
            }
          },
          {
            "if": {
              "properties": { "subtype": { "const": "peptide" } },
              "required": ["subtype"]
            },
            "then": {
              "properties": {
                "subtypeData": {
                  "type": "object",
                  "properties": {
                    "sequence": { "type": "string" }
                  },
                  "required": ["sequence"]
                }
              },
              "required": ["subtypeData"]
            }
          }
        ]
      }
    },
    {
      "if": {
        "properties": { "type": { "const": "liquid" } },
        "required": ["type"]
      },
      "then": {
        "properties": {
          "volume": {
            "type": "object",
            "title": "Volume",
            "required": ["value", "unit"],
            "properties": {
              "value": {
                "type": "number",
                "title": "Volume"
              },
              "unit": {
                "type": "string",
                "title": "Unit",
                "default": "µL",
                "enum": ["fL", "pL", "nL", "µL", "mL", "L", "kL", "ML", "GL"]
              }
            }
          }
        },
        "required": ["volume"]
      }
    },
    {
      "if": {
        "properties": { "type": { "const": "solution" } },
        "required": ["type"]
      },
      "then": {
        "properties": {
          "components": {
            "type": "array",
            "items": {
              "type": "object",
              "properties": {
                "type": {
                  "enum": ["solid", "liquid"]
                },
                "name": { "type": "string" }
              },
              "required": ["type", "name"],
              "allOf": [
                {
                  "if": {
                    "properties": { "type": { "const": "solid" } },
                    "required": ["type"]
                  },
                  "then": {
                    "properties": {
                      "mass": {
                        "type": "object",
                        "title": "Mass",
                        "required": ["value", "unit"],
                        "properties": {
                          "value": {
                            "type": ["number", "null"],
                            "title": "Mass"
                          },
                          "unit": {
                            "type": "string",
                            "title": "Unit",
                            "default": "mg",
                            "enum": ["pg", "ng", "µg", "mg", "g", "kg", "t", "kt"]
                          }
                        }
                      },
                      "massConcentration": {
                        "type": "object",
                        "title": "Mass Concentration",
                        "required": ["value", "unit"],
                        "properties": {
                          "value": {
                            "type": ["number", "null"],
                            "title": "Mass Concentration"
                          },
                          "unit": {
                            "type": "string",
                            "title": "Unit",
                            "default": "mg/L",
                            "enum": [ "g/L", "mg/L", "µg/L", "ng/L", "pg/L", "fg/L", "g/mL", "mg/mL", "µg/mL", "ng/mL", "pg/mL", "fg/mL"]
                          }
                        }
                      },
                      "molarConcentration": {
                        "type": "object",
                        "title": "Molar Concentration",
                        "required": ["value", "unit"],
                        "properties": {
                          "value": {
                            "type": ["number", "null"],
                            "title": "Molar Concentration"
                          },
                          "unit": {
                            "type": "string",
                            "title": "Unit",
                            "default": "M",
                            "enum": ["fM", "pM", "nM", "µM", "mM", "M", "kM", "MM", "GM"]
                          }
                        }
                      },
                      "molarMass": {
                        "type": "object",
                        "title": "Molar Mass",
                        "required": ["value", "unit"],
                        "properties": {
                          "value": {
                            "type": ["number", "null"],
                            "title": "Molar Mass"
                          },
                          "unit": {
                            "type": "string",
                            "title": "Unit",
                            "default": "g/mol",
                            "enum": ["g/mol"]
                          }
                        }
                      },
                      "nbMoles": {
                        "type": "object",
                        "title": "Number of Moles",
                        "required": ["value", "unit"],
                        "properties": {
                          "value": {
                            "type": ["number", "null"],
                            "title": "Number of Moles"
                          },
                          "unit": {
                            "type": "string",
                            "title": "Unit",
                            "default": "mol",
                            "enum": ["fmol", "pmol", "nmol", "µmol", "mmol", "mol", "kmol", "Mmol", "Gmol"]
                          }
                        }
                      },
                      "subtype": {
                        "enum": ["dna", "peptide"]
                      },
                      "subtypeData": {
                        "type": "object"
                      }
                    },
                    "required": []
                  }
                },
                {
                  "if": {
                    "properties": { "type": { "const": "liquid" } },
                    "required": ["type"]
                  },
                  "then": {
                    "properties": {
                      "volume": {
                        "type": "object",
                        "title": "Volume",
                        "required": ["value", "unit"],
                        "properties": {
                          "value": {
                            "type": "number",
                            "title": "Volume"
                          },
                          "unit": {
                            "type": "string",
                            "title": "Unit",
                            "default": "µL",
                            "enum": ["fL", "pL", "nL", "µL", "mL", "L", "kL", "ML", "GL"]
                          }
                        }
                      }
                    },
                    "required": ["volume"]
                  }
                },
                {
                  "if": {
                    "properties": { "subtype": { "const": "dna" } },
                    "required": ["subtype"]
                  },
                  "then": {
                    "properties": {
                      "subtypeData": {
                        "type": "object",
                        "properties": {
                          "sequence": { "type": "string" },
                          "is_single_stranded": { "type": "boolean" }
                        },
                        "required": ["sequence", "is_single_stranded"]
                      }
                    },
                    "required": ["subtypeData"]
                  }
                },
                {
                  "if": {
                    "properties": { "subtype": { "const": "peptide" } },
                    "required": ["subtype"]
                  },
                  "then": {
                    "properties": {
                      "subtypeData": {
                        "type": "object",
                        "properties": {
                          "sequence": { "type": "string" }
                        },
                        "required": ["sequence"]
                      }
                    },
                    "required": ["subtypeData"]
                  }
                }
              ]
            }
          }
        },
        "required": ["components"]
      }
    }
  ]
}


const uiSchema = {
  "ui:submitButtonOptions": {
    "norender": true
  },
  "mass": {
    "ui:field": "ValueWithUnit"
  },
  "molarMass": {
    "ui:field": "ValueWithUnit"
  },
  "nbMoles": {
    "ui:field": "ValueWithUnit"
  },
  "volume": {
    "ui:field": "ValueWithUnit"
  },
  "components": {
    "items": {
      "mass": {
        "ui:field": "ValueWithUnit"
      },
      "massConcentration": {
        "ui:field": "ValueWithUnit"
      },
      "molarConcentration": {
        "ui:field": "ValueWithUnit"
      },
      "molarMass": {
        "ui:field": "ValueWithUnit"
      },
      "nbMoles": {
        "ui:field": "ValueWithUnit"
      },
      "volume": {
        "ui:field": "ValueWithUnit"
      }
    }
  }
}


export {
  schema,
  uiSchema
};
